/*
 |-----------------------------------------------------------------------------
 | El branding conocido de cada host
 |-----------------------------------------------------------------------------
 | Módulo propio y no dentro de `apply` ni de `prime` porque los dos lo
 | necesitan y en el mismo archivo se harían un ciclo: `apply` guarda cuando
 | pinta, `prime` lee antes del primer render.
 |
 | Va en `localStorage` y no en memoria porque el objetivo es justo sobrevivir a
 | la recarga. A diferencia del token de sesión —que vive sólo en memoria a
 | propósito, ver `useSession`— esto no es un secreto: son el nombre, el logo y
 | los colores que `GET /tenant/branding` sirve sin autenticar y que cualquier
 | cliente final ve en cada galería.
 */

import type { Branding } from './apply'

/** La clave lleva el host: el tema es POR DOMINIO, y en el mismo navegador
 *  conviven el panel de un estudio y la galería de otro. */
const key = (): string => `chasquitambo:branding:${window.location.hostname}`

export function rememberBranding(branding: Branding): void {
  try {
    window.localStorage.setItem(key(), JSON.stringify(branding))
  } catch {
    // Safari en privado y las cuotas llenas lanzan aquí. Recordar el tema es
    // una mejora, no un requisito: si falla, se paga un parpadeo y ya.
  }
}

export function recallBranding(): Branding | null {
  try {
    const stored = window.localStorage.getItem(key())

    return stored === null ? null : (JSON.parse(stored) as Branding)
  } catch {
    return null
  }
}
